import { langSegment } from '@tmf-ui-routes/i18n-segments/lang-segment.i18n-segment';
import { maintenanceI18nSegment } from '@tmf-ui-routes/i18n-segments/maintenance.i18n-segment';

export function maintenanceRoutePath(): string {
  return `/${langSegment()}/${maintenanceI18nSegment()}/`;
}
